module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-info gv-inverted-color-scheme",
    attrs: {
      "id": "gv-difesa-suolo-foto-info"
    }
  }, [_vm._c('div', {
    directives: [{
      name: "draggable",
      rawName: "v-draggable"
    }],
    staticClass: "gv-difesa-suolo-foto-info-title gv-color-scheme",
    attrs: {
      "id": "gv-difesa-suolo-foto-info-title"
    }
  }, [_vm._c('strong', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._c('el-button', {
    staticClass: "gv-close gv-color-scheme",
    attrs: {
      "icon": "el-icon-close",
      "type": "button",
      "title": "Chiudi Panello",
      "alt": "Chiudi Panello"
    },
    on: {
      "click": _vm.closePanel
    }
  })], 1), _vm._v(" "), _vm._c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }]
  }, [_vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-info-body",
    attrs: {
      "id": "gv-difesa-suolo-foto-info-body"
    }
  }, [_vm._c('div', {
    staticClass: "gv-difesa-suolo-foto-info-scheda"
  }, [_vm._c('div', {
    staticStyle: {
      "font-size": "20px",
      "width": "90%"
    }
  }, [_vm._c('strong', [_vm._v("NOME FILE: ")]), _vm._v(" " + _vm._s(_vm.properties.file_name) + "\n        ")]), _vm._v(" "), _vm._c('div', {
    staticStyle: {
      "font-size": "20px",
      "width": "90%"
    }
  }, [_vm._c('strong', [_vm._v("DATA: ")]), _vm._v(" " + _vm._s(_vm.properties.datetime) + "\n        ")]), _vm._v(" "), _vm._c('div', {
    staticStyle: {
      "font-size": "20px",
      "width": "90%"
    }
  }, [_vm._c('el-checkbox', {
    on: {
      "change": _vm.toggleValidate
    },
    model: {
      value: (_vm.properties.validato),
      callback: function($$v) {
        _vm.$set(_vm.properties, "validato", $$v)
      },
      expression: "properties.validato"
    }
  }, [_vm._v("Validato")]), _vm._v(" "), _vm._c('span', {
    staticClass: "gv-difesa-suolo-foto-label"
  }, [_vm._v("Direzione")]), _vm._v(" "), _vm._c('el-input', {
    staticStyle: {
      "width": "33px"
    },
    attrs: {
      "id": "gv-difesa-suolo-foto-direzione",
      "size": "mini",
      "maxlength": "3",
      "placeholder": "Direzione",
      "type": "integer"
    },
    model: {
      value: (_vm.properties.direzione),
      callback: function($$v) {
        _vm.$set(_vm.properties, "direzione", $$v)
      },
      expression: "properties.direzione"
    }
  }), _vm._v(" "), _vm._c('span', {
    staticClass: "gv-difesa-suolo-foto-degree"
  }, [_vm._v("°")]), _vm._v(" "), _vm._c('el-button', {
    staticClass: "gv-color-scheme fas fa-hand-point-down",
    attrs: {
      "id": "gv-measure-point",
      "title": "Sposta",
      "size": "mini"
    },
    on: {
      "click": _vm.measurePoint
    }
  }), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('el-button', {
    ref: "button",
    attrs: {
      "id": "gv-difesa-suolo-foto-info-submit",
      "title": "Salva",
      "type": "primary",
      "size": "mini",
      "disabled": !_vm.changed
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n            Salva\n          ")]), _vm._v(" "), _vm._c('el-button', {
    ref: "button",
    attrs: {
      "id": "gv-difesa-suolo-foto-info-delete",
      "title": "Cancella Foto",
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.deletePhoto()
      }
    }
  }, [_vm._v("\n            Cancella Foto\n          ")])], 1), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('div', {
    staticStyle: {
      "font-size": "20px",
      "width": "90%"
    }
  }, [_vm._c('a', {
    attrs: {
      "href": _vm.properties.url,
      "target": "_blank"
    }
  }, [_vm._c('img', {
    attrs: {
      "width": "300px",
      "src": _vm.properties.url
    }
  })])]), _vm._v(" "), _vm._c('div', {
    staticStyle: {
      "font-size": "20px",
      "width": "90%"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dd7f8058!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DifesaSuoloFotoInfo.vue
// module id = 911
// module chunks = 39